import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "32.143",
  width: "50",
  viewBox: "0 0 50 32.143",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25.002 0c-4.657 0-8.535 3.278-9.472 7.653H9.696C4.34 7.653 0 11.987 0 17.343v5.103c0 5.357 4.34 9.696 9.696 9.696h15.306c4.435 0 8.282-3.278 9.382-7.653h5.925c5.1 0 9.43-4.34 9.69-9.7v-5.1C50 4.33 45.66 0 40.31 0H25.003zm0 4.08h15.306c3.06 0 5.61 2.55 5.356 5.61v5.103c0 3.062-2.554 5.616-5.615 5.616h-5.36v-3.07c0-5.36-4.34-9.69-9.69-9.69h-5.46c.84-2.08 2.92-3.58 5.46-3.58zM9.696 11.735h5.61v3.06c0 5.356 4.34 9.695 9.697 9.695h5.2c-.83 2.073-2.858 3.572-5.2 3.572H9.695c-3.06 0-5.615-2.554-5.615-5.616v-5.102c0-3.06 2.555-5.61 5.616-5.61zm9.437 0h5.87c3.06 0 5.61 2.55 5.61 5.61v3.065h-5.87c-3.06 0-5.61-2.556-5.61-5.617v-3.06z"
  })]
});